'use client';

import { useCallback } from 'react';
import useUser from '@alltrails/context/hooks/useUser';
import useHeatmapsTierValidation from '@alltrails/heatmaps/hooks/useHeatmapsTierValidation';
import { updateDynamicStyleIds } from '@alltrails/maps/redux/reducer';
import type { User } from '@alltrails/types/User';
import { useAppDispatch, useAppSelector } from '@/utils/redux';
import { setIsTrailMapOpen } from '@/utils/trailPageSlice';

export default function useCommunityHeatmap() {
  const dispatch = useAppDispatch();
  const dynamicStyleIds = useAppSelector(state => state.map.dynamicStyleIds);
  const contextUser = useUser();
  const { showHeatmapsUpsellModal, onHeatmapsUpsellModalCloseRequest, handleHeatmapFailedEntitlementCheck } = useHeatmapsTierValidation();

  const openCommunityHeatmap = useCallback(
    (user: User | null = contextUser) => {
      const applyStyles = () => {
        if (!dynamicStyleIds.includes('newHeatmap')) {
          dispatch(updateDynamicStyleIds([...dynamicStyleIds, 'newHeatmap']));
        }
      };
      dispatch(setIsTrailMapOpen(true));
      if (user?.featureEntitlements?.includes('community_heat_maps')) {
        applyStyles();
      } else {
        handleHeatmapFailedEntitlementCheck(applyStyles);
      }
    },
    [contextUser, dispatch, dynamicStyleIds, handleHeatmapFailedEntitlementCheck]
  );

  return { openCommunityHeatmap, showHeatmapsUpsellModal, onHeatmapsUpsellModalCloseRequest };
}
